import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class CartLink extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.addEventListener('click', () => dispatchEvent('cartlink:overlay'));
    document.addEventListener('cart:loaded', ({ detail }) => {
      if (detail?.cart?.item_count >= 0) {
        this.refs.count.textContent = `(${detail.cart.item_count})`;
      }
    });
  }
}

customElements.define('cart-link', CartLink);
